<template>
<div class="adding-personal-label-master">
    <div class="adding-personal-label-wrap">
        <div>
            <h3>Унесите Податке: </h3>
            <p>
                Назив: 
                <input type="text" v-model="perosnalLabelName" :maxlength="inputLength">
            </p>
            <p>
                Број рачуна: 
                <input type="text" v-model="receiptNumber" :maxlength="inputLength">
            </p>
            <p>
                Датум издавања рачуна:
                <input type="date" v-model="receiptDate">
            </p>
            <p>
                Број извода из банке: 
                <input type="text"  v-model="bankNumber" :maxlength="inputLength">
            </p>
            <p>
                Сопствени допринос (у динарима): 
                <input type="text" v-model="personalSpendings" :maxlength="inputLength">
            </p>
            <p>
                Фотографија рачуна: 
                <input type="file" @change="resizeReceipt" ref="receiptImg">
            </p>
            <p>
                Фотографија извода из банке:  
                <input type="file" @change="resizeBankImg" ref="bankImg">
            </p>
            <p>
                <button @click="sendingRequest">Потврди</button>
                <button @click="close">Одустани</button>
            </p>
        </div>
    </div>

    <success-popup
        v-if="successPopupOpened"
        @close="closeSuccessPopup">
      </success-popup>

    <error-msg v-if="displayError" @close="displayError=false" :msgText="errMsg" :fatal="isFatal"/>
</div>
  
</template>

<script>
import SuccessPopup from '@/components/SuccessPopup.vue'
import ErrorMsg from '../components/ErrorMsg'
import extraData from '../extraData.js'
import axios from 'axios'

export default {
    components:{
        SuccessPopup,
        ErrorMsg
  },
    props:{
        labelIdToChange: Number,
        labelNameToChange: String,
        projectId: Number
    },
    data(){
        return {
            personalSpendings: 0,
            officialSpending: 0,
            perosnalLabelName:"",
            receiptNumber:"",
            receiptDate:"",
            bankNumber:"",
            receiptNewImg: null,
            bankNewImg: null,
            resizeCounter: 0,
            inputLength:200,
            successPopupOpened: false,
            errMsg:'',
            displayError:false,
            isFatal:false
        }
    },
    methods:{
        resizeReceipt(){
            if(this.$refs.receiptImg.files[0].size<400000){
                this.receiptNewImg = this.$refs.receiptImg.files[0];
                return;
            }
            this.resizeImg(this.$refs.receiptImg.files[0],'rec');
        },
        resizeBankImg(){
            if(this.$refs.bankImg.files[0].size<400000){
                this.bankNewImg = this.$refs.bankImg.files[0];
                return;
            }
            this.resizeImg(this.$refs.bankImg.files[0],'bank');
        },
        sendingRequest(){
            if(this.checkInputs()){return;}
            let formData = new FormData();
            formData.append('sid', sessionStorage.getItem("sid"));
            if(this.labelIdToChange){
                formData.append('stavkaId', this.labelIdToChange);
            }
            if(this.labelNameToChange){
                formData.append('kategorija', this.labelNameToChange);
                // console.log(this.labelNameToChange)
            }
            formData.append('proId', this.projectId);
            // formData.append('status','лично');
            formData.append('racunSlika', this.receiptNewImg);
            formData.append('izvodSlika', this.bankNewImg);
            formData.append('racunBroj', this.receiptNumber);
            formData.append('racunDatum', this.receiptDate);
            formData.append('izvodBroj', this.bankNumber);
            formData.append('ime',this.perosnalLabelName);
            // formData.append('opstinsko', this.officialSpending);
            formData.append('licno', this.personalSpendings);
            axios.post(extraData.adress+"request/personal",formData).then((res)=>{
                if (res.data.res==="ok"){
                    this.errMsg=''
                    this.displayError=false
                    this.isFatal=false
                    // console.log(res);
                    this.successPopupOpened=true;
                }
                else{
                    this.errMsg=res.data.msg
                    this.displayError=true
                    if (res.data.msg==="Нисте улоговани") this.isFatal=true
                }

            }).catch(() => {
                    // console.log(e)
                    this.errMsg="Дошло је до проблема при конектовању на сервер"
                    this.displayError=true
                    this.isFatal=true
            })
            
        },
        showInputError(msg){
            this.errMsg=msg;
            this.isFatal=false;
            this.displayError=true;
        },
        checkInputs(){
            if(this.perosnalLabelName.trim().length<5){this.showInputError('Назив мора имати бар 5 слова'); return true;}
            if(this.receiptNumber.trim().length===0){this.showInputError('Морате унети број рачуна'); return true;}
            if(this.receiptDate.trim().length===0){this.showInputError('Морате унети датум издавања рачуна'); return true;}
            if(this.bankNumber.trim().length===0){this.showInputError('Морате унети број извода из банке'); return true;}
            if(isNaN(parseFloat(this.personalSpendings))){this.showInputError('Сопствени допринос мора бити унет као број'); return true;}
            if(this.$refs.receiptImg.files.length===0){this.showInputError('Морате додати слику рачуна'); return true;}
            if(this.$refs.bankImg.files.length===0){this.showInputError('Морате додати слику извода из банке'); return true;}
            return false;
        },
        resizeImg(imgFile, targetInfo){
            let reader= new FileReader();
            reader.readAsDataURL(imgFile);
            reader.onload= (e)=>{
                const MAX_WIDTH = 1200;
                const MAX_HEIGHT = 1200;
                let img = document.createElement("img");

                img.src = e.target.result;
                let width = img.width;
                let height = img.height;

                if((width===0 || height===0) && this.resizeCounter<3){
                    this.resizeCounter++;
                    this.resizeImg(imgFile, targetInfo);
                    return;
                }
                this.resizeCounter=0;
 
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }
                
                let canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) =>{
                    if(targetInfo==='rec'){
                        this.receiptNewImg = new File([blob], imgFile.name, { type: imgFile.type });
                        // console.log(this.receiptNewImg);
                    }
                    if(targetInfo==='bank'){
                        this.bankNewImg = new File([blob], imgFile.name, { type: imgFile.type });
                        // console.log(this.bankNewImg);
                    }
                }, imgFile.type, 0.50);

            }
        },
        closeSuccessPopup(){
            this.successPopupOpened=!this.successPopupOpened;
            this.close();
        },
        close(){
            this.$emit("close");
        }
    }
}
</script>

<style lang="scss" scoped>
    .adding-personal-label-wrap{
        @include PopupStyling();
        h3{
            text-align: center;
        }
        >div>p{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        input[type=text]{
            text-align: right;
            flex-basis: 220px;
            flex-shrink: 0;
        }
        input[type=date]{
            text-align: center;
            flex-basis: 220px;
            flex-shrink: 0;
        }
        input[type=file]{
            flex-basis: 234px;
            flex-shrink: 0;
            border: 1px solid #888;
            border-radius: 5px;
            cursor: pointer;
        }
        button{
            @include ButtonStyling();
        }
    }

    @media only screen and (max-width: 768px) {
        .adding-personal-label-wrap{
            font-size: 0.8rem;
            >div{
                padding: 5px;
            }
        }
    }
</style>